<template>
	<div class="debugConsole">
		<p><span>current conditions:</span> {{scstr}}</p>
		<p><span>search words:</span> {{w}}</p>
		<p><span>checked:</span> {{ checked | json }}</p>
		<p><span>checkedImage:</span> {{ checkedImage | json }}</p>
		<p><span>slider values:</span> {{ sliderValue | json }}</p>
		<!-- <p>defaultChecked: {{ defaultChecked | json }}</p>
		<p>defaultSliderValue: {{ defaultSliderValue | json }}</p> -->
		<!-- <p>{{prefectures}}</p> -->
	</div>
</template>

<script>
import { getSearchWords, getSearchConditions, getChecked, getSliderValue, getSCStr, getPrefecturesList, getCheckedImage } from '../vuex/getters';
import { defaultChecked, defaultSliderValue } from '../vuex/default_values';
module.exports = {
	vuex: {
		getters: {
			w: getSearchWords,
			c: getSearchConditions,
			checked: getChecked,
			checkedImage: getCheckedImage,
			sliderValue: getSliderValue,
			scstr: getSCStr,
			prefecturesList: getPrefecturesList
		}
	},
	data: function(){
		return {
			defaultChecked: defaultChecked(),
			defaultSliderValue: defaultSliderValue()
		};
	},
	created: function(){
		// console.log('debugConsole created');
	},
	ready: function(){
		// console.log(this.prefectures);
		// console.log(this.checkedImage);
	}
};
</script>

<style scoped lang="scss">
.debugConsole{
	font-size: 12px;
	color: #fff;
	background-color: rgba(0,0,0,.8);
	display: none;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 100;
	padding: 10px;

	span{
		color: #aaa;
	}
}
</style>



// WEBPACK FOOTER //
// debug_console.vue?34cda24c